import { useState } from "react";
import { apiPost, errorMessage } from "../api";
import { AppHQLogo } from "../Logo";

/** Device-code confirmation page the CLI opens (/cli-login?code=...). The owner approves with
 *  their existing web session (established by a passkey). */
export function CliLogin({ auth }: { auth: "loading" | "in" | "out" }) {
  const code = new URLSearchParams(window.location.search).get("code") ?? "";
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">("idle");
  const [error, setError] = useState<string | null>(null);

  async function approve() {
    setState("busy");
    setError(null);
    try {
      const r = await apiPost("/api/auth/cli/approve", { code });
      if (!r.ok) throw new Error(await errorMessage(r, "Autoriseren mislukt."));
      setState("done");
    } catch (e) {
      setState("error");
      setError(e instanceof Error ? e.message : "Er ging iets mis.");
    }
  }

  return (
    <div className="auth-screen">
      <div className="glass-card">
        <div className="logo-wrap">
          <AppHQLogo size={72} />
        </div>
        <h1>CLI koppelen</h1>
        {!code ? (
          <p className="sub">Geen code gevonden. Start opnieuw met <code>apphq login</code>.</p>
        ) : auth === "loading" ? (
          <div className="logo-wrap">
            <div className="spinner" style={{ borderTopColor: "var(--accent)", borderColor: "rgba(10,132,255,.25)" }} />
          </div>
        ) : auth === "out" ? (
          <>
            <p className="sub">Log eerst in met je passkey om de CLI te autoriseren.</p>
            <button className="btn btn-primary" onClick={() => (window.location.href = "/")}>
              Naar inloggen
            </button>
          </>
        ) : state === "done" ? (
          <p className="sub">Gelukt. Je kunt terug naar de terminal.</p>
        ) : (
          <>
            <p className="sub">Autoriseer de <code>apphq</code> CLI op dit apparaat.</p>
            <button className="btn btn-primary" onClick={approve} disabled={state === "busy"}>
              {state === "busy" ? <span className="spinner" /> : null}
              {state === "busy" ? "Bezig…" : "CLI autoriseren"}
            </button>
          </>
        )}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}
